/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
//
// When the feature flag "FocusMode" will be enabled, this action will no longer be needed, the feature will be registered by the PropertiesDOM feature.
//
define([
	'../../../../widgets/livewidget/nls/StringResources',
	'../../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../../lib/@waca/dashboard-common/dist/api/ContentActionsProviderAPI'
], function (StringResources, APIFactory, ContentActionsProviderAPI) {

	class FilterDockAction {

		constructor({ features }) {
			this._dashboard = features.API;
			this._contentActions = features.ContentActions;
			this._dashboardState = features.DashboardState;
			this._icons = features.Icons;
		}

		initialize() {
			this._api = APIFactory.createAPI(this, [ContentActionsProviderAPI]);
			this._contentActions.registerProvider('filterDock', this.getAPI());
		}

		getAPI() {
			return this._api;
		}

		// idList: determines whether the action is canvas action or content action
		// Actions appearing in the top right eg. slot, properties are canvas action and
		// For canvas actions the idList is empty and for content actions idList will be an array of selected contents
		getContentActionList(idList) {
			let contribution = [];
			if (idList.length === 0) {
				const canvasExtensions = this._getCanvasExtensions();
				if (canvasExtensions) {
					const filterDockControl = canvasExtensions.getExtension('filterDockCollapseControl');
					if (filterDockControl) {
						const filterIcon = this._icons.getIcon('common-filter');
						contribution = [{
							name: 'filterDock',
							baseClass: 'toolbar',
							order: 3,
							label: StringResources.get('filterIconLabel_Single'),
							text: StringResources.get('filterIconLabel_Single'),
							className: 'buttonWithText',
							icon: filterIcon.id,
							type: 'ToggleButton',
							checked: filterDockControl.isExpanded(),
							disabled: this._buttonRendered.bind(this),
							action: this._expandFilterDock.bind(this),
							offAction: this._collapseFilterDock.bind(this),
							decoratorView: {
								viewModule: 'dashboard-analytics/features/dashboard/actions/filterDock/ActiveFilterView',
								viewOptions: {
									dashboardAPI: this._dashboard
								}
							}
						}];
					}
				}
			}

			return contribution;
		}

		_getCanvasExtensions() {
			if (!this._canvasExtensions) {
				this._canvasExtensions = this._dashboard.getDashboardCoreSvc('.CanvasExtensions');
			}
			return this._canvasExtensions;
		}

		_buttonRendered() {
			const canvasExtensions = this._getCanvasExtensions();
			if (!canvasExtensions) {
				return false;
			}

			const filterDockControl = canvasExtensions.getExtension('filterDockCollapseControl');
			const filterDock = canvasExtensions.getExtension('filterDock');
			filterDockControl.$el.addClass('toolbarControlled');
			filterDock.$el.addClass('toolbarControlled');
			return this._dashboardState.getUiState().eventGroups;
		}

		_expandFilterDock() {
			this._dashboard.triggerDashboardEvent('filterDock:expand');
		}

		_collapseFilterDock() {
			this._dashboard.triggerDashboardEvent('filterDock:collapse');
		}
	}
	return FilterDockAction;
});
